<div class="flex flex-col lg:flex-row justify-center items-start gap-2 md:gap-4">

	<div class="w-full lg:w-1/4 flex justify-center items-start gap-2">
		<div class="w-1/4">
			<img *ngIf="review.productImages != ''"
				 [src]="review.productImages!.split(',')[0]"
				 (click)="onUserProvidedImagesClick(review.productImages)"
				 alt=""
				 class="w-[80px] h-[80px] rounded border-2 border-[#6c5b48] cursor-pointer">
			<img *ngIf="review.productImages == ''"
				 src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg"
				 alt=""
				 class="w-[80px] h-[80px] rounded border-2 border-[#6c5b48]">
		</div>
		<div class="w-full lg:w-3/4 flex flex-col justify-center items-start">
			<p class="text-[#000]">{{ review.name }}</p>
			<p class="text-xs text-end text-[#9c8a6c]"><span *ngIf="review.city">{{ review.city }},</span> {{ review.country }}</p>
			<p class="text-xs text-end text-[#9c8a6c]">{{ review.createdAt |  date: 'dd MMM YYYY' }}</p>
		</div>
	</div>

	<div class="w-full lg:w-3/4 flex-col justify-start">
		<div class="flex items-center gap-1">
			<span *ngFor="let _ of stars; let i = index">
				<span class="star" [class.filled]="review.rating > i">&#9733;</span>
			</span>
		</div>
		<div class="flex flex-col">
			<a *ngIf="review.link && review.description"
			   target="_blank"
			   href="{{review.link}}"
			   class="text-sm sm:text-base text-[#000] block hover:text-[#000] hover:underline">
				<q>{{ review.description }}</q>
			</a>
			<p *ngIf="!review.link"
			   class="text-sm sm:text-base text-[#000]">
				<q>{{ review.description }}</q>
			</p>
			<p class="text-sm my-2">
				<span>Purchased item: </span>
				<a *ngIf="review.product"
				   [href]="prepareProductRedirectionUrl(review.product)"
				   target="_blank"
				   class="underline text-[#9c8a6c]">{{ (review.product.sku) }}</a>
			</p>
		</div>
	</div>
</div>
